import { MouseEventHandler } from 'react';
import { clsx } from 'clsx';

import { Icons } from '@monoimin/atoms';

type CarouselButtonProps = {
  direction: 'left' | 'right';
  onClick?: MouseEventHandler;
  className?: string;
};

export const CarouselButton = ({
  direction,
  onClick,
  className,
}: CarouselButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'z-10 rounded-full w-12 h-12 text-white bg-black flex items-center justify-center',
        className
      )}
    >
      <Icons
        sizeClassName='w-6 h-6'
        icon='dropdown'
        isInteractive
        className={clsx('bg-white', {
          'rotate-90': direction === 'left',
          '-rotate-90': direction === 'right',
        })}
      />
    </button>
  );
};
